<template>
  <section>
      <TopNavbar />
      <div class="wrapper">
     <AddJobModal />
     </div>
  </section>
</template>

<script>
import AddJobModal from "./AddJobBtnModal";
import TopNavbar from '../../Navigations/TopNavbar';
export default {
components: {
    AddJobModal,
    TopNavbar
}
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 80px 30px 0 30px;
}
</style>
